export type TCRUDEvents = 'created' | 'updated' | 'deleted';

export type TOrderCRUDEvents = TCRUDEvents | 'driver_not_found' | 'client_arrived' | 'ahead';

export type TEventMessage<T, B> = { source: string; event: B; data: T };

export enum CASHBACK_ERROR_CODE {
  CASHBACK_UNAVAILABLE_FOR_BRANCH = 10601,
  CHANGED_CONDITIONS = 10602,
  CASHBACK_UNAVAILABLE = 10603,
}
